<div class="treenode">
  <div>
    @if (CanExpand && !Expanded) {
      <span class="fa fa-chevron-right" (click)="Toggle()"></span>
    }
    @if (CanExpand && Expanded) {
      <span class="fa fa-chevron-down" (click)="Toggle()"></span>
    }
    <span class="node-text" [ngClass]="{ 'is-active' : Selected}"  (click)="HandleClick($event)" (dblclick)="HandleDoubleClick($event)">
      @if (Image != null) {
        <img class="node-image" [src]="Image" />
      }
      {{Text}}
    </span>
    @if (CanDelete) {
      <span (click)="HandleDelete($event)" class="has-text-grey-light"><i class="fa fa-trash"></i> </span>
    }
  </div>
  @if (Expanded) {
    <div class="node-content">
      <ng-content></ng-content>
    </div>
  }
</div>